<script setup>
import { computed, ref } from 'vue';
import { useStore, useStoreGetters } from 'dashboard/composables/store';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';

import Dialog from 'next/dialog/Dialog.vue';

const store = useStore();
const getters = useStoreGetters();
const { t } = useI18n();

const bot = ref({});
const dialogRef = ref(null);
const uiFlags = getters['wgptBots/getUIFlags'];

const description = computed(() => {
  return `${t('WGPT_BOTS.DELETE.CONFIRM.MESSAGE')} ${bot.value.name}?`;
});

const handleDialogConfirm = async () => {
  const id = bot.value.id;
  if (!id) return;

  try {
    await store.dispatch('wgptBots/delete', id);
    useAlert(t('WGPT_BOTS.DELETE.API.SUCCESS_MESSAGE'));
  } catch (error) {
    useAlert(t('WGPT_BOTS.DELETE.API.ERROR_MESSAGE'));
  } finally {
    dialogRef.value?.close();
  }
};

const open = selectedBot => {
  bot.value = selectedBot;
  dialogRef.value?.open();
};

defineExpose({ open });
</script>

<template>
  <Dialog
    ref="dialogRef"
    type="alert"
    :title="t('WGPT_BOTS.DELETE.TITLE')"
    :description="description"
    :confirm-button-label="t('WGPT_BOTS.DELETE.CONFIRM.YES')"
    :cancel-button-label="t('WGPT_BOTS.DELETE.CONFIRM.NO')"
    :is-loading="uiFlags.isDeleting"
    @confirm="handleDialogConfirm"
  />
</template>
